{
    "header_tab__STORAGE_LOCATION": "Entrepôts",
    "header_tab__CLERK": "Saisisseurs",
    "header_tab__SALES_REP": "Commerciaux",
    "header_tab__CUSTOMER": "Clients",
    "header_tab__INDUSTRY": "Secteurs",
    "header_tab__PRODUCT": "Articles",
    "header_tab__PRODUCT_GROUP": "Groupes d'articles",
    "header_tab__SUPPLIER": "Fournisseurs",
    "header_tab__NORMALISED_CATEGORY": "Groupes de marchandises",
    "filter_dropdown_status__label": "Indicateur",
    "filter_dropdown_status__billed": "Chiffre d'affaires",
    "filter_dropdown_status__billed_wo_credit_note": "Chiffre d'affaires (hors avoirs)",
    "filter_dropdown_status__unbilled": "Chiffre d'affaires non facturé",
    "filter_dropdown_status__order_sum": "Montant des commandes",
    "filter_dropdown_unit__label": "Unité",
    "filter_dropdown_unit__monetary": "Valeur",
    "filter_dropdown_unit__units": "Quantité",
    "filter_dropdown__period_label": "Périodes",
    "filter_dropdown__period": "{{years}} périodes",
    "radio_option__revenue": "Chiffre d'affaires",
    "radio_option__margin": "Marge (chiffre d'affaires)",
    "radio_option__order_sum": "Montant des commandes",
    "radio_option__order_sum_margin": "Marge (commandes)",
    "table_label__revenue_spark_chart": "CA 24 derniers mois",
    "table_label__order_sum_spark_chart": "Montant des commandes 24 derniers mois",
    "table_label__unbilled_spark_chart": "CA non facturé 24 derniers mois",
    "table_label__billed_wo_credit_note_spark_chart": "CA hors avoirs 24 derniers mois",
    "table_label__units_spark_chart": "Quantité 24 derniers mois",
    "table_label__order_count_spark_chart": "Commandes 24 derniers mois",
    "table_label__units_current": "Quantité",
    "table_label__units_last_period": "Quantité année précédente",
    "table_label__units_delta_amount": "Écart",
    "table_label__units_delta_percentage": "Écart %",
    "table_label__revenue_period": "CA {{period}}",
    "table_label__order_sum_period": "Montant des commandes {{period}}",
    "table_label__unbilled_period": "CA non facturé {{period}}",
    "table_label__billed_wo_credit_note_period": "CA hors avoirs {{period}}",
    "table_label__margin_period": "MB {{period}}",
    "table_label__margin_pct_period": "MB % {{period}}",
    "table_label__period_YTD": "{{period}} cumul annuel",
    "table_label__period_TODAY": "{{period}} aujourd'hui",
    "table_label__period_YESTERDAY": "{{period}} hier",
    "table_label__period_FULL_YEAR": "{{period}} année complète",
    "table_label__period_LAST_WEEK": "{{period}} semaine dernière",
    "table_label__period_LAST_MONTH": "{{period}} mois dernier",
    "table_label__period_LAST_QUARTER": "{{period}} 3 derniers mois",
    "table_label__period_TTM": "{{period}} 12 derniers mois",
    "table_label__period_CUSTOM_DATES": "{{from, datetime}}-{{to, datetime}}",
    "table_label__gross_margin_current": "MB",
    "table_label__gross_margin_percentage_current": "MB %",
    "table_label__gross_margin_last_period": "MB année précédente",
    "table_label__gross_margin_percentage_last_period": "MB % année précédente",
    "table_label__gross_margin_delta_amount": "Écart",
    "table_label__gross_margin_delta_percentage": "Écart %",
    "table_label__revenue_delta_amount": "Écart",
    "table_label__revenue_delta_percentage": "Écart %",
    "search_placeholder__STORAGE_LOCATION": "Rechercher un entrepôt",
    "search_placeholder__CLERK": "Rechercher un saisisseur",
    "search_placeholder__SALES_REP": "Rechercher un commercial",
    "search_placeholder__CUSTOMER": "Rechercher un client",
    "search_placeholder__INDUSTRY": "Rechercher un secteur",
    "search_placeholder__PRODUCT": "Rechercher un article ",
    "search_placeholder__PRODUCT_GROUP": "Rechercher un groupe d'articles",
    "search_placeholder__SUPPLIER": "Rechercher un fournisseur",
    "search_placeholder__NORMALISED_CATEGORY": "Rechercher un groupe de marchandises",
    "revenue_stats__title": "Total du chiffre d'affaires",
    "revenue_stats__title_order_sum": "Total des commandes reçues",
    "revenue_stats__sub_title_ytd": "Année en cours · {{range}} chaque année",
    "revenue_stats__sub_title_ttm": "12 derniers mois · au {{date}}",
    "total_summary__name": "Total",
    "total_summary__name_tooltip": "Remarque : certains filtres peuvent entraîner un double comptage du chiffre d'affaires.",
    "explorer__export": "Exporter",
    "explorer__export_confirmation_title": "Conseils pour l'utilisation des données exportées",
    "explorer__export_confirmation_content_1": "<strong>Ouvrir le fichier :</strong><br/> Plato exporte toutes les données dans un fichier Excel (.xlsx). Vous pouvez l'ouvrir directement dans Microsoft Excel, Google Sheets ou d'autres tableurs.",
    "explorer__export_confirmation_content_2": "<strong>Filtrer avant l'export :</strong><br/> Pensez à définir les filtres comme la période, la catégorie ou le statut de facturation avant l'export, afin de ne traiter que les données pertinentes.",
    "explorer__export_confirmation_content_3": "<strong>Protéger les données sensibles :</strong><br/> Si votre export contient des données confidentielles comme la marge brute, stockez et partagez le fichier de manière sécurisée. Respectez toujours les directives de protection des données de votre entreprise.",
    "explorer__export_confirmation_accept": "Exporter",
    "explorer__export_no_data_title": "Aucune donnée à exporter",
    "explorer__export_no_data_description": "Aucune ligne ne correspond aux filtres actuels.",
    "explorer__export_failed_title": "Échec de l'export",
    "explorer__export_failed_description": "Veuillez réessayer. Si le problème persiste, contactez le support."
}
